import React from 'react'
import SchoolBanner from './Components/SchoolBanner'
import SchoolBody from './Components/SchoolBody'
import SchoolAuth from './Components/SchoolAuth'
import IndexFooter from '../Index/Components/IndexFooter'
// import TopBar from '../ProjectComponents/TopBar'
import SEOHelmet from '../ProjectComponents/SEOHelmet'

function SchoolPage() {
  const page = 'school'
  return (
    <>
        {/* topbar */}
        <SEOHelmet page={page} />
        <div className='bg-main main'>
          {/* <TopBar/> */}
          <SchoolBanner/>
        </div>
        {/* body */}

        <SchoolBody/>
        <SchoolAuth/>

        {/* footer */}
        <IndexFooter/>
    </>
  )
}

export default SchoolPage